var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningTriangleIcon = function SvgWarningTriangleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB700",
    d: "M55.203 41.023 33.34 3.055a6.19 6.19 0 0 0-10.675 0L.803 41.023a5.88 5.88 0 0 0 0 5.93A6.09 6.09 0 0 0 6.14 50h43.725a6.09 6.09 0 0 0 5.333-3.047 5.88 5.88 0 0 0 .005-5.93M26.003 20a2 2 0 1 1 4 0v10a2 2 0 0 1-4 0zm2 22a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
  })));
};
export default SvgWarningTriangleIcon;